<template>
  <WebChapterTemplate
    page-title="新闻史青年学者论坛"
    section-label="学科建设"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
  >
    <div class="forum-manual">
      <section class="forum-section">
        <div class="forum-section__header">
          <h2 class="forum-section__title">新闻史青年学者论坛</h2>
          <p class="forum-section__summary">
            自 2015 年起，新闻与传播研究所联合中国新闻史学会及相关高校持续举办新闻史青年学者论坛。
          </p>
        </div>

        <div class="forum-grid">
          <article
            v-for="card in cards"
            :key="card.title"
            class="forum-card"
          >
            <figure class="forum-card__figure">
              <img :src="card.src" :alt="card.title" loading="lazy" />
            </figure>
            <div class="forum-card__body">
              <h3 class="forum-card__title">{{ card.title }}</h3>
              <p class="forum-card__text">{{ card.description }}</p>
            </div>
          </article>
        </div>
      </section>
    </div>
  </WebChapterTemplate>
</template>

<script>
import WebChapterTemplate from '@/components/WebChapterTemplate.vue';

export default {
  name: 'Lanhuxinwenshiqingnian',
  components: {
    WebChapterTemplate
  },
  data() {
    return {
      sectionRoute: '/lanhu_xuekeyukeyan',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      cards: [
        {
          title: '2015 年第一届新闻史青年学者论坛',
          src: require('./assets/html/forum-2015.jpg'),
          description: '2015 年 9 月，新闻与传播研究所、中国新闻史学会主办，南京大学紫金传媒学院承办的第一届新闻史青年学者论坛合影。'
        },
        {
          title: '2016 年第二届新闻史青年学者论坛',
          src: require('./assets/html/forum-2016.jpg'),
          description: '2016 年 11 月，新闻与传播研究所、中国新闻史学会主办，华中科技大学新闻与信息传播学院承办的第二届新闻史青年学者论坛合影。'
        },
        {
          title: '2017 年第三届新闻史青年学者论坛',
          src: require('./assets/html/forum-2017.jpg'),
          description: '2017 年 9 月，新闻与传播研究所、中国新闻史学会主办，华中科技大学新闻与信息传播学院承办的第三届新闻史青年学者论坛合影。'
        },
        {
          title: '2018 年第四届新闻史青年学者论坛',
          src: require('./assets/html/forum-2018.jpg'),
          description: '2018 年 9 月，新闻与传播研究所、中国新闻史学会主办，山东大学新闻传播学院承办的第四届新闻史青年学者论坛合影。'
        }
      ]
    };
  }
};
</script>

<style scoped>
.forum-manual {
  display: grid;
  gap: 32px;
}

.forum-section {
  padding: 26px;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.18);
  background:
    linear-gradient(140deg, rgba(248, 242, 233, 0.84), rgba(255, 255, 255, 0) 42%),
    linear-gradient(180deg, #fff, rgba(253, 250, 246, 0.96));
  box-shadow: 0 14px 30px rgba(59, 41, 17, 0.05);
}

.forum-section__header {
  margin-bottom: 24px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(179, 145, 101, 0.16);
}

.forum-section__title {
  margin: 0;
  color: #f25c19;
  font-size: 26px;
  line-height: 1.4;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
  font-weight: 700;
}

.forum-section__summary {
  margin: 10px 0 0;
  color: #6b5b4b;
  font-size: 16px;
  line-height: 1.8;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.forum-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.forum-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.16);
  background: #fff;
  box-shadow: 0 10px 24px rgba(45, 33, 16, 0.05);
}

.forum-card__figure {
  margin: 0;
  background: #f8f4ee;
}

.forum-card__figure img {
  display: block;
  width: 100%;
  height: auto;
}

.forum-card__body {
  padding: 18px 18px 20px;
}

.forum-card__title {
  margin: 0 0 8px;
  color: #2f2a25;
  font-size: 20px;
  line-height: 1.5;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 600;
}

.forum-card__text {
  margin: 0;
  color: #4c433a;
  font-size: 17px;
  line-height: 1.9;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

@media (max-width: 1024px) {
  .forum-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .forum-section {
    padding: 18px;
  }

  .forum-section__title {
    font-size: 24px;
  }

  .forum-card__title {
    font-size: 18px;
  }

  .forum-card__text,
  .forum-section__summary {
    font-size: 16px;
    line-height: 1.8;
  }
}
</style>
